import { createContext, useContext } from 'react';
import { BehaviorSubject } from 'rxjs';
import { useObservableValue } from '../../../../hooks/useObservable';

/** Lets workflow steps react to being revealed after the overview is dismissed (e.g. to re-arm hover validation). */
export const WorkflowOverviewVisibleContext = createContext(false);
export const useIsWorkflowOverviewVisibleInContext = () => useContext(WorkflowOverviewVisibleContext);

/** Shares overview visibility between the drawer header and the drawer content, which render in separate trees. */
export type WorkflowOverviewStore = BehaviorSubject<boolean>;

export function createWorkflowOverviewStore(initialVisible: boolean): WorkflowOverviewStore {
  return new BehaviorSubject(initialVisible);
}

export function useIsWorkflowOverviewVisible(store: WorkflowOverviewStore) {
  return useObservableValue(() => store, [store], store.getValue());
}

/** Context guide values are read with lodash `get`, so the ID must not contain dots. */
export function getWorkflowOverviewSkipGuideID(overviewID: string) {
  return `workflowOverviewSkipped:${overviewID}`;
}
